import { curriculumGateway } from '../curriculum-gateway';

import { LearningContents, Slide } from '@types';

export interface SlidesParams {
    page?: number;
    per_page?: number;
    sort?: string;
}

export const getSlides = async (
    learningObjectiveId: number,
    params: SlidesParams = {},
): Promise<Slide[]> => {
    return curriculumGateway
        .get(`/learning_objectives/${learningObjectiveId}/slides`, {
            params,
            withCredentials: true,
        })
        .then((response) => {
            return response.data;
        })
        .catch(() => {
            throw new Error('Something went wrong loading the slides');
        });
};

export interface SlideValues {
    tutor_notes?: string;
    active?: boolean;
    image_path?: { name: string; base64: string };
    components_path?: { name: string; base64: string };
    name?: string;
    position?: number;
    learning_content?: LearningContents;
}

export const createSlide = async (
    learningObjectiveId: number,
    values: SlideValues,
): Promise<Slide> => {
    const data = {
        slide: {
            tutor_notes: values.tutor_notes,
            active: values.active,
            content: values.image_path && values.image_path.base64,
            position: Number(values.position),
            name: values.image_path && values.image_path.name,
            learning_content_id:
                values.learning_content && values.learning_content.id,
            components_file:
                values.components_path && values.components_path.base64,
        },
    };
    return curriculumGateway
        .post(`/learning_objectives/${learningObjectiveId}/slides`, data, {
            withCredentials: true,
        })
        .then((response) => {
            return response.data;
        })
        .catch(() => {
            throw new Error('Something went wrong creating the slide.');
        });
};

export const editSlide = async (
    id: number,
    learningObjectiveId: number,
    values: SlideValues,
): Promise<Slide> => {
    const data = {
        slide: {
            tutor_notes: values.tutor_notes,
            active: values.active,
            content: values.image_path && values.image_path.base64,
            position: Number(values.position),
            name: values.image_path && values.image_path.name,
            learning_content_id:
                values.learning_content && values.learning_content.id,
            components_file:
                values.components_path && values.components_path.base64,
        },
    };

    return curriculumGateway
        .put(`/learning_objectives/${learningObjectiveId}/slides/${id}`, data, {
            withCredentials: true,
        })
        .then((response) => {
            return response.data;
        })
        .catch(() => {
            throw new Error('Something went wrong editing the slide.');
        });
};

export const deleteSlide = async (
    id: number,
    learningObjectiveId: number,
): Promise<void> => {
    return curriculumGateway
        .delete(`/learning_objectives/${learningObjectiveId}/slides/${id}`, {
            withCredentials: true,
        })
        .then((response) => {
            return response.data;
        })
        .catch(() => {
            throw new Error('Something went wrong deleting the slide.');
        });
};
